module.exports = __webpack_public_path__ + "img/bohui.06c03367.png";